import { IconButton, useTheme } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

type Props = {
  onClick: () => void;
  size?: 'small' | 'medium' | 'large';
  disabled?: boolean;
};

export const AddTestPointButton = ({
  onClick,
  size = 'small',
  disabled = false
}: Props) => {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';

  return (
    <IconButton
      onClick={onClick}
      size={size}
      disabled={disabled}
      sx={{
        color: isDarkMode ? 'rgba(66, 165, 245, 0.9)' : 'primary.main',
        backgroundColor: 'transparent',
        border: '1px solid',
        borderColor: isDarkMode ? 'rgba(66, 165, 245, 0.6)' : 'primary.main',
        '&:hover': {
          backgroundColor: 'rgba(66, 165, 245, 0.12)',
          borderColor: isDarkMode ? 'rgba(66, 165, 245, 0.8)' : 'primary.dark'
        },
        p: 1
      }}
    >
      <AddIcon fontSize={size} />
    </IconButton>
  );
};

export default AddTestPointButton;
